import React from 'react';
import PropTypes from 'prop-types';
import Icon from './Icon';

export default class AudioFile extends Icon {
  gradientId = this.getRandomId();

  icon = (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <defs>
        <linearGradient
          id={this.gradientId}
          x1="2.538%"
          x2="100%"
          y1="2.538%"
          y2="100%"
        >
          <stop offset="0%" stopColor="#00ABDD" />
          <stop offset="100%" stopColor="#009DD3" />
        </linearGradient>
      </defs>
      <g fill="none" fillRule="evenodd" opacity={this.props.opacity}>
        <rect width="40" height="40" fill={`url(#${this.gradientId})`} rx="5" />
        <path
          fill="#FFF"
          d="M32 8c0-.294-.132-.572-.363-.763-.185-.153-.421-.237-.662-.237-.057 0-.114.005-.17.014l-16.4 2.666c-.497.082-.857.496-.857.987v13.586c-.466-.234-.986-.385-1.555-.452-.214-.025-.434-.038-.655-.038-1.096 0-2.22.306-3.248.886-1.237.697-2.198 1.717-2.704 2.874-.55 1.254-.511 2.52.107 3.565s1.723 1.711 3.113 1.875c.213.025.433.037.654.037 1.096 0 2.22-.306 3.249-.885 1.237-.698 2.198-1.718 2.704-2.874.254-.58.384-1.166.385-1.741V13.588l14.352-2.333v10.331c-.466-.234-.986-.385-1.555-.451-.214-.026-.435-.038-.655-.038-1.096 0-2.22.306-3.249.885-1.237.696-2.197 1.717-2.703 2.873-.55 1.255-.512 2.522.107 3.567.617 1.045 1.723 1.71 3.112 1.874.213.025.434.037.654.037 1.097 0 2.22-.306 3.25-.885 1.237-.697 2.197-1.718 2.703-2.874.254-.58.385-1.166.386-1.74V8z"
        />
      </g>
    </svg>
  );
}

AudioFile.defaultProps = {
  opacity: '1.0',
};

AudioFile.propTypes = {
  opacity: PropTypes.string,
};
